(() => {
  const detailsElements = document.querySelectorAll('.product-eol');
  if (!detailsElements.length) return;

  const hoverQuery = window.matchMedia(
    '(hover: hover) and (pointer: fine)'
  );

  const GAP = 8;
  const VIEWPORT_PADDING = 12;

  const items = Array.from(detailsElements, details => {
    const summary = details.querySelector('summary');
    const icon = details.querySelector('.eol-icon');
    const popup = details.querySelector('.product-eol__popup');

    if (!summary || !icon || !popup) return null;

    return {
      details,
      summary,
      icon,
      popup
    };
  }).filter(Boolean);

  if (!items.length) return;

  function positionPopup(item) {
    const { details, icon, popup } = item;

    if (!details.open) {
      popup.classList.remove('product-eol__popup--positioned');
      return;
    }

    const iconRect = icon.getBoundingClientRect();
    const detailsRect = details.getBoundingClientRect();

    const popupWidth = popup.offsetWidth;
    const popupHeight = popup.offsetHeight;

    let left;
    let top;

    const availableRight =
      window.innerWidth -
      VIEWPORT_PADDING -
      iconRect.right;

    if (availableRight >= popupWidth + GAP) {
      left =
        iconRect.right -
        detailsRect.left +
        GAP;

      top =
        iconRect.top +
        iconRect.height / 2 -
        detailsRect.top -
        popupHeight / 2;
    } else {
      const availableAbove =
        iconRect.top - VIEWPORT_PADDING;

      if (availableAbove >= popupHeight + GAP) {
        top =
          iconRect.top -
          detailsRect.top -
          popupHeight -
          GAP;
      } else {
        top =
          iconRect.bottom -
          detailsRect.top +
          GAP;
      }

      left =
        iconRect.left -
        detailsRect.left;
    }

    const absoluteLeft = detailsRect.left + left;

    if (absoluteLeft < VIEWPORT_PADDING) {
      left =
        VIEWPORT_PADDING -
        detailsRect.left;
    } else if (
      absoluteLeft + popupWidth >
      window.innerWidth - VIEWPORT_PADDING
    ) {
      left =
        window.innerWidth -
        VIEWPORT_PADDING -
        popupWidth -
        detailsRect.left;
    }

    const absoluteTop = detailsRect.top + top;

    if (absoluteTop < VIEWPORT_PADDING) {
      top =
        VIEWPORT_PADDING -
        detailsRect.top;
    } else if (
      absoluteTop + popupHeight >
      window.innerHeight - VIEWPORT_PADDING
    ) {
      top =
        window.innerHeight -
        VIEWPORT_PADDING -
        popupHeight -
        detailsRect.top;
    }

    popup.style.setProperty(
      '--eol-left',
      `${Math.round(left)}px`
    );

    popup.style.setProperty(
      '--eol-top',
      `${Math.round(top)}px`
    );

    popup.classList.add(
      'product-eol__popup--positioned'
    );
  }

  function closeAll(except = null) {
    for (const item of items) {
      if (
        item !== except &&
        item.details.open
      ) {
        item.details.open = false;
      }
    }
  }

  for (const item of items) {
    const {
      details,
      summary,
      icon
    } = item;

    details.addEventListener('toggle', () => {
      positionPopup(item);
    });

    icon.addEventListener('mouseenter', () => {
      if (!hoverQuery.matches) return;

      closeAll(item);

      if (!details.open) {
        details.open = true;
      }
    });

    icon.addEventListener('mouseleave', () => {
      if (
        hoverQuery.matches &&
        details.open
      ) {
        details.open = false;
      }
    });

    summary.addEventListener('click', event => {
      if (hoverQuery.matches) return;

      event.preventDefault();

      const shouldOpen = !details.open;

      closeAll(item);
      details.open = shouldOpen;
    });
  }

  document.addEventListener('click', event => {
    if (!event.target.closest('.product-eol')) {
      closeAll();
    }
  });

  let resizeFrame = 0;

  window.addEventListener(
    'resize',
    () => {
      if (resizeFrame) {
        cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = 0;

        for (const item of items) {
          if (item.details.open) {
            positionPopup(item);
          }
        }
      });
    },
    { passive: true }
  );
})();